// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2338) return "static/chunks/2338.3d68b8c86ec33b3c.js";
	if (chunkId === 6295) return "static/chunks/6295.4a1ea4f8ddbdcf7e.js";
	if (chunkId === 5240) return "static/chunks/5240.ff5b9d670e84d1e8.js";
	if (chunkId === 2022) return "static/chunks/2022.f3cee1ef7de714e3.js";
	if (chunkId === 9630) return "static/chunks/9630.99bbe578bce05884.js";
	if (chunkId === 3615) return "static/chunks/3615.3ae243d213df1546.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2208":"c4f5be77","7006":"120c2625"}[chunkId] || chunkId) + "-" + {"196":"5f8ca4879aab29cf","2208":"a0034e0555bbce09","2317":"631b3b2a66c0c1ab","3647":"52dd43d898900f90","4198":"61af6e0b98758067","5301":"779db9e2938170d8","7006":"00133a1cbfebcbec","9537":"f5c4bb42e06e4997","9562":"9836443d06d91d4e"}[chunkId] + ".js";
};